/**
 * datas: Group form's data    array
 *     ex) datas = [{
 *             type: Group from's type
 *             name: Group from's name
 *             value: Group from's value
 *             onChange: Group from's onChange
 *             required: Group from's required
 *             readOnly: Group from's readOnly
 *
 *             if type is combo. option plus
 *             combos [
 *                 { value: "", name: "" },
 *                 { value: "", name: "" },
 *             ]
 *
 *             if type is radio. option plus
 *             items [
 *                 { value: "", name: "" },
 *                 { value: "", name: "" },
 *             ]
 *
 *             if type is checkbox. option plus and onChange function position in items.
 *             items [
 *                 { checked: "", name: "", onChange: (e) => {} },
 *                 { checked: "", name: "", onChange: (e) => {} },
 *             ]
 *         }]
 * columnCount: Group form's column count in one row    number
 *
 *
 *
 *
 *
 *
 */

import React from "react";
/** Components Import */
import BasicDatepicker from "./Datepicker_Basic";
import BasicCombo from "./Combo_Basic";
import BasicRadio from "./Radio_Basic";
import GroupCheckbox from "./Checkbox_Group";
import BasicButton from "./Button_Basic";

function FormGroup({ datas = [], columnCount = 2 }) {
  let count = columnCount;
  return (
    <div className="formGroup_info_box">
      {datas.map((item, index) => {
        if (item.fullWidth) {
          columnCount = 1;
        } else {
          columnCount = count;
        }

        const ReturnInputs = () => {
          switch (item.type) {
            case "date":
              return (
                <BasicDatepicker
                  style={{ width: "100%" }}
                  className="formGroup_info_datepicker"
                  selected={item.value}
                  onChange={(e) => item.onChange(e)}
                  defaultValue={item.defaultValue}
                  readOnly={item.readOnly ? true : false}
                />
              );
            case "dateTime":
              return (
                <BasicDatepicker
                  className="formGroup_info_datepicker formGroup_info_datepicker_time"
                  inputStyle={{
                    width: 200,
                    onfocus: "this.blur()",
                    inputMode: "none",
                  }}
                  selected={item.value}
                  onChange={(e) => item.onChange(e)}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                />
              );
            case "combo":
              return (
                <BasicCombo
                  wrapClass="input"
                  containerClass="formGroup_info_combo_container"
                  combos={item.combos}
                  value={item.value}
                  onChange={(e) => item.onChange(e)}
                />
              );
            case "button":
              return (
                <BasicButton
                  wrapClass="input"
                  name={item.btnName}
                  onClick={(e) => {
                    item.onClick(e);
                  }}
                />
              );
            case "radio":
              return (
                <BasicRadio
                  style={item.style}
                  items={item.items}
                  value={item.value}
                  onChange={(e) => item.onChange(e)}
                  gubun={item.gubun}
                />
              );
            case "checkbox":
              return <GroupCheckbox items={item.items} />;
            case "fileUpload":
              return (
                <input
                  type="file"
                  id="fileUpload"
                  name="fileUpload"
                  onChange={(e) => item.onChange(e)}
                  accept="image/*"
                  // webkitdirectory="true"
                />
              );

            default:
              return (
                <input
                  className="input"
                  style={{
                    backgroundColor: item.readOnly ? "#e4e4e4" : "#fff",
                  }}
                  type={item.inputType ? item.inputType : "text"}
                  inputMode={item.inputMode ? item.inputMode : "text"}
                  value={item.value}
                  onChange={(e) => item.onChange(e)}
                  readOnly={item.readOnly ? true : false}
                  onClick={(e) => {
                    if (item.clicked) {
                      item.onClick(e);
                    }
                  }}
                />
              );
          }
        };

        return (
          <div
            key={index}
            className={"content-box content-box-width" + columnCount}
          >
            <dt
              className={
                item.required
                  ? "formGroup_info_dt_required"
                  : "formGroup_info_dt"
              }
            >
              <span>{item.name}</span>
            </dt>
            <dd>{ReturnInputs()}</dd>
          </div>
        );
      })}
    </div>
  );
}

export default FormGroup;
